import { apiClient } from "../../Config/ApiClient";

export const retrieveHoliday = (token, data) => apiClient.get(`/holidays`, { headers: {'Authorization': token}, params: data });

export const createHoliday = (token, data) => apiClient.post(`/holidays/add`, data, { headers: {'Authorization': token}});

export const updateHoliday = (token, data, id) => apiClient.post(`/holidays/update/${id}`, data, { headers: {'Authorization': token}});

export const deleteHoliday = (token, id) => apiClient.post(`/holidays/delete/${id}`, {}, { headers: {'Authorization': token }});